import InvestorPortalRoute from "../../../components/Admin/InvestorPortal/InvestorPortalRoute";

export function withInvestorPortalGuard(Component, requireCapability = "investorPortal") {
  return function GuardedPage(props) {
    return (
      <InvestorPortalRoute requireCapability={requireCapability}>
        <Component {...props} />
      </InvestorPortalRoute>
    );
  };
}

export function withMarketplaceGuard(Component) {
  return function GuardedMarketplacePage(props) {
    return (
      <InvestorPortalRoute requireCapability="marketplace">
        <Component {...props} />
      </InvestorPortalRoute>
    );
  };
}

export function withCooperativeRequestGuard(Component) {
  return function GuardedCooperativePage(props) {
    return (
      <InvestorPortalRoute requireCapability="cooperativeRequest">
        <Component {...props} />
      </InvestorPortalRoute>
    );
  };
}

export function withRealEstateGuard(Component) {
  return function GuardedRealEstatePage(props) {
    return (
      <InvestorPortalRoute requireCapability="realEstate">
        <Component {...props} />
      </InvestorPortalRoute>
    );
  };
}

export function withServiceRequestsGuard(Component) {
  return function GuardedServiceRequestsPage(props) {
    return (
      <InvestorPortalRoute requireCapability="serviceRequests">
        <Component {...props} />
      </InvestorPortalRoute>
    );
  };
}
